define('module/CartModule',['require','marionette','view/module/cart/CartView','view/module/cart/CartIconView','view/module/cart/CartBookingDetailsTotalView','model/CartModel'],function (require) {
	
	var Marionette = require('marionette');
    var CartView = require('view/module/cart/CartView');
    var CartIconView = require('view/module/cart/CartIconView');
    var CartBookingDetailsTotalView = require('view/module/cart/CartBookingDetailsTotalView');
	var CartModel = require('model/CartModel');

	/**
	 * Cart module
     * Aggregates all cart related plugins
	 * 
	 * @class CartModule
	 */
	return Marionette.Object.extend({
		
		_region: null,
		_iconRegion: null,
		_iconSecondaryRegion: null,
		_model: null,
		_view: null,
		_iconView: null,
		_detailsStepView: null,

		/**
		 * Inits instance
		 */
		initialize: function () {
			this._iconRegion = this.getOption('layout').addRegion('cart', '#sb_cart');
			this._iconSecondaryRegion = this.getOption('layout').addRegion('cartSecondary', '#sb_cart_secondary');
			this._region = this.getOption('layout').addRegion('cartPopup', '#sb_cart_popup');
			this._model = new CartModel();
		},

        addItem: function (item, regionId) {
            this._model.addItem(item);
            this.updateView();

			return this._view[regionId];
        },

        updateView: function () {
            if (!this._view && this._model.hasItems()) {
                this._view = new CartView({
					model: this._model,
				});
				this.listenTo(this._view, 'checkout', this.checkout.bind(this));
                this._region.show(this._view);

				this._iconView = new CartIconView({
					model: this._model
				});
				this.listenTo(this._iconView, 'toggle:popup', this.onTogglePopup.bind(this));
				this._iconRegion.show(this._iconView);

				try {
					this._iconSecondaryRegion._ensureElement();

					var secondaryIconView = new CartIconView({
						model: this._model
					});
					this.listenTo(secondaryIconView, 'toggle:popup', this.onTogglePopup.bind(this));
					this._iconSecondaryRegion.show(secondaryIconView);
				} catch (e) {
					// just ignore, we don't have a place for secondary button
				}
            }
        },

		onTogglePopup: function () {
			if (this._view) {
				this._view.onTogglePopup();
			}
		},

		checkout: function () {
			this._model.triggerCheckout()
		},

		afterCheckout: function () {
			this._model.triggerAfterCheckout();
		},

		setStepManager: function (stepManager) {
			if (this._stepManager) return;

			this._stepManager = stepManager;
			this.listenTo(this._stepManager, 'step:render:details', this.beforeDetailsShow);
		},

		beforeDetailsShow: function (step, view, region) {
			this._detailsStepView = view;

			view.addRegion('cart_total', '#sb_cart_total_container');

			if (this._model.getTotal()) {
				view.showChildView('cart_total', new CartBookingDetailsTotalView({
					model: this._model,
					bookingModel: this._stepManager.getBookingModel()
				}));
				view.hidePackageLinkBlock();
			}
		}

	});
	
});
